import fpApiUtil from "./fp-api-util";

// FP 생산 계획 보정(그리드) 화면 서비스 — old AdjustmentGrid3.jsx의 zAxios 호출 4종 대응.
// 백엔드는 AdjustmentController(@RequestMapping("/factoryplan/adjustment/")) + CommonController.

// 보정 그리드 조회(크로스탭). 응답 = { header: string[], data: AdjustmentCrosstabDto[] }.
// AdjustmentCrosstabDto는 plantCd/plantNm/resourceCd/resourceNm + pivotData(Object[], 각 원소가
// AdjustmentsDto 또는 null)를 갖는다 — 셀 값이 숫자가 아니라 "작업(activity) 객체"인 게 이 화면의 특징.
const getAdjustments = (params) => fpApiUtil.postParams("factoryplan/adjustment/grid3", params);

// 보정(잘라내기/붙여넣기, 수량 보정/분할) 결과 재정렬 요청.
// AdjustmentController#getArrangedData가 request.getParameter("changes")와 "params"를 **각각** 읽으므로
// postChanges가 아니라 postFields를 쓴다(fp-frontend.md §0-2, §B-9의 planScope 폴백 사유와 동일).
// changes = { original: AdjustmentsDto[], adjusted: AdjustmentsDto[] } — 서버가 id 기준으로 원본을
// 보정분으로 교체한 뒤 (plant, stage, resource, planDt, seq)로 재정렬해 다시 크로스탭으로 내려준다.
//
// FP 조회 중 유일하게 **multipart**를 쓴다(postFields 아님). 자원 2그룹 × 3개월이면 changes 가
// 1MB를 넘는데, urlencoded 로 보내면 퍼센트 인코딩으로 1.5배가 돼 Tomcat maxPostSize(2MB)를
// 넘기고 **파라미터가 조용히 비워진다**. old도 이 호출만 FormData 였다 — fp-api-util 주석 참고.
const getArrangedActivities = (params, changes) =>
  fpApiUtil.postMultipartFields("factoryplan/adjustment/grid3/arranged-activities", { params, changes });

// 공정(routeCd)별 대체 자원 목록 — 응답 = Map<routeCd, BorDto[]>.
// 붙여넣기 대상 자원이 잘라낸 작업들의 대체 자원인지 검증하는 데 쓴다(old checkAllAltResources).
const getAltResources = (params) => fpApiUtil.postParams("factoryplan/adjustment/alt-resources", params);

// 자원 목록(조회조건 멀티셀렉트 옵션) — CommonController POST /factoryplan/resources.
// fp-common-service의 getToolResources와 같은 엔드포인트지만 isTool 필터를 걸지 않는다(old 동일).
const getResources = (params) => fpApiUtil.postParams("factoryplan/resources", params);

// 작업 상세 정보(컨텍스트 메뉴) — 응답 = ActivityDetailDto. 자원 간트의 `resource-gantt/activity/detail`과
// **같은 DTO**이고 `itemCd`/`resourceCd`/`routeCd`/`customerCd`를 "코드 (명칭)"으로 합쳐 내리는 것,
// `setTimeString()`으로 `tsDiff`/`woTsDiff`를 채우는 것까지 동일하다 → 상세 패널 섹션 구성을 공유한다.
// 조회 대상 테이블만 다르다(이쪽은 보정 결과 `adjustments`라 이 화면 데이터와 일치한다).
// 파라미터: planScope / versionCd / plantCd / resourceCd / activityId.
const getAdjustmentsDetail = (params) => fpApiUtil.postParams("factoryplan/adjustment/grid3/detail", params);

const fpAdjustmentGridService = {
  getAdjustments, getArrangedActivities, getAltResources, getResources, getAdjustmentsDetail
};
export default fpAdjustmentGridService;
